import { shippingMethodList } from '@/constants/types';
import { triggerCustomGTMEvent } from './gtm';
import { getProductTitleNameWithModelAndElement } from './string';

const getFormattedProductsForGTM = (items) => {
  console.log({ items });

  if (!Array.isArray(items) || items?.length === 0) {
    return [];
  }

  return items.map((item) => ({
    sku: item.sku,
    name: getProductTitleNameWithModelAndElement(item),
    price: item.price?.final_price || item.price?.regular_price,
    quantity: item.cart_quantity || 1,
    category: item?.category?.name?.en || 'Unknown',
    brand: item?.brand?.name?.en || 'Unknown',
  }));
};

export const addToCartGTMEvent = ({ productData, cartQuantity = 1 }) => {
  triggerCustomGTMEvent('addToCartButtonClick', {
    eventLabel: `add_item | ${productData?.sku} | ${getProductTitleNameWithModelAndElement(productData)}`,
    ecommerce: {
      click: {
        "actionField'": { list: 'product' },
        products: getFormattedProductsForGTM([
          { ...productData, cart_quantity: cartQuantity },
        ]),
      },
    },
  });
};

export const checkoutGTMEvent = ({ cartItems, totalAmount, savings }) => {
  triggerCustomGTMEvent('checkoutButtonClick', {
    ecommerce: {
      checkout: {
        actionField: { step: 1, option: 'begin checkout' },
        products: getFormattedProductsForGTM(cartItems),
      },
      currencyCode: 'BDT',
      value: totalAmount,
      savings: {
        percentage: savings?.percentage || 0,
        amount: savings?.amount || 0,
      },
    },
  });
};

export const placeOrderGTMEvent = ({ orderDetails, totalAmount, savings }) => {
  triggerCustomGTMEvent('placeOrderButtonClick', {
    ecommerce: {
      checkout: {
        actionField: {
          step: 'submit_order',
          option: 'place_order_button_click',
        },
        products: getFormattedProductsForGTM(orderDetails?.items),
      },
      currencyCode: 'BDT',
      value: totalAmount,
      savings,
    },
  });
};

export const purchaseSuccessGTMEvent = ({
  orderDetails,
  totalAmount = 0,
  savings = {},
}) => {
  triggerCustomGTMEvent('orderPurchaseSuccess', {
    eventLabel: `purchase_success | ${orderDetails?.orderId || 'unknown'} | ${orderDetails?.paymentMethod || 'unknown'} | ${shippingMethodList[orderDetails?.shippingMethod] || 'unknown'}`,
    ecommerce: {
      purchase: {
        actionField: {
          id: orderDetails?.orderId,
          revenue: totalAmount,
          tax: 0,
          shipping: orderDetails?.shippingCost,
          coupon: orderDetails?.couponCode,
        },
        products: getFormattedProductsForGTM(orderDetails.orderItems),
      },
      currencyCode: 'BDT',
      value: totalAmount,
      savings,
    },
  });
};
